import { FormControlData, FormControlValue, CreateFormControlProps, ICollectionSelect } from "../model";
import { createFormControl } from "solid-forms";
import { Label, Select, Error } from "../views";
import { createEffect, createRenderEffect, splitProps, createComponent, createReaction } from "solid-js";
import { state } from ":mods";
import { SelectViewProps } from "../model";
import { Fragment } from "solid-js/h/jsx-runtime";
export function createSelect<V extends FormControlValue, D extends FormControlData = FormControlData>(
  ...args: CreateFormControlProps<V, D>
): ICollectionSelect<V, D> {
  const control = createFormControl<V, D>(...args);
  const name = String(control.id);
  return {
    control,
    name,
    Label: (props) => <Label control={control} for={name} {...props} />,
    Error: (props) => <Error control={control} {...props} />,
    Select: (props) => <Select control={control} name={name} {...props} />,
  };
}
